export default __webpack_public_path__ + "static/media/icon2.495239f6.svg";